import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { validateField, validation } from './validation';

function isEmpty(value: number | null): boolean {
  return value === null;
}

/**
 * NETSUITE_MASTER_PROJECT custom field: the project id in `integer_value`
 * (legacy `SplashlightNetsuiteMasterProjectSelector`). Options come from the
 * integration through the field registry, not from the definition.
 */
export const netsuiteMasterProjectCodec: FieldCodec<'netsuite-master-project'> =
  {
    decode(entity, spec, ctx) {
      const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
      return row?.integer_value ?? null;
    },
    encode(value) {
      return {
        type: 'custom',
        columns: customFieldColumns({ integer_value: value })
      };
    },
    empty() {
      return null;
    },
    isEmpty,
    validate(value, spec) {
      return validateField(value, spec, isEmpty, value =>
        value !== null && !Number.isInteger(value)
          ? validation.invalid({ code: 'invalid-project' })
          : validation.valid()
      );
    }
  };
